const accountDialogObservers = new WeakMap();
const pendingAccountDialogObservers = new WeakSet();
const mobileMenuObservers = new WeakMap();
const megaMenuItems = new WeakSet();

function syncMobileMenuState(details) {
  const header = details.closest('#header-component');
  if (!header) return;

  header.classList.toggle('k9-mobile-menu-open', details.open);
}

function observeMobileMenu(details) {
  if (mobileMenuObservers.has(details)) return;

  const observer = new MutationObserver(() => syncMobileMenuState(details));
  observer.observe(details, { attributes: true, attributeFilter: ['open'] });
  mobileMenuObservers.set(details, observer);
  syncMobileMenuState(details);
}

function initializeMobileMenuState() {
  document.querySelectorAll('#Details-menu-drawer-container').forEach(observeMobileMenu);
}

function observeMegaMenuItem(item) {
  if (megaMenuItems.has(item)) return;

  let closeTimer;

  item.addEventListener('pointerenter', () => {
    window.clearTimeout(closeTimer);
    item.classList.add('k9-global-nav__item--open');
  });

  item.addEventListener('pointerleave', () => {
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(() => {
      item.classList.remove('k9-global-nav__item--open');
    }, 180);
  });

  megaMenuItems.add(item);
}

function initializeMegaMenuHover() {
  document.querySelectorAll('.k9-global-nav__item--has-children').forEach(observeMegaMenuItem);
}

function updateAccountDialogScrollbarOffset() {
  const pageWrapper = document.querySelector('.page-wrapper');
  if (!pageWrapper || document.documentElement.classList.contains('k9-account-dialog-open')) return;

  const scrollbarOffset = Math.max(0, pageWrapper.offsetWidth - pageWrapper.clientWidth);
  document.documentElement.style.setProperty('--k9-account-dialog-scrollbar-offset', `${scrollbarOffset}px`);
}

function syncAccountDialogState(dialog) {
  const root = document.documentElement;
  root.classList.toggle('k9-account-dialog-open', dialog.open);

  if (!dialog.open) updateAccountDialogScrollbarOffset();
}

function hideRedundantAccountHomeLink(account) {
  if (!account.hasAttribute('data-k9-home-page')) return;

  account.shadowRoot?.querySelectorAll('dialog a[href]').forEach((link) => {
    const label = link.textContent?.replace(/\s+/g, ' ').trim();

    if (label !== 'トップページに戻る') return;

    link.hidden = true;
    link.style.setProperty('display', 'none', 'important');
    link.setAttribute('aria-hidden', 'true');
  });
}

function observeAccountDialog(account) {
  if (accountDialogObservers.has(account) || pendingAccountDialogObservers.has(account)) return;

  pendingAccountDialogObservers.add(account);
  let attempts = 0;

  const connectObserver = () => {
    const dialog = account.shadowRoot?.querySelector('dialog');

    if (!dialog) {
      attempts += 1;

      if (attempts < 300) {
        window.requestAnimationFrame(connectObserver);
      } else {
        pendingAccountDialogObservers.delete(account);
      }

      return;
    }

    const observer = new MutationObserver(() => {
      syncAccountDialogState(dialog);
      hideRedundantAccountHomeLink(account);
    });
    observer.observe(dialog, { attributes: true, attributeFilter: ['open'], childList: true, subtree: true });
    accountDialogObservers.set(account, observer);
    pendingAccountDialogObservers.delete(account);
    syncAccountDialogState(dialog);
    hideRedundantAccountHomeLink(account);
  };

  connectObserver();
}

async function initializeAccountDialogLayout() {
  await customElements.whenDefined('shopify-account');
  updateAccountDialogScrollbarOffset();
  document.querySelectorAll('shopify-account').forEach(observeAccountDialog);
}

initializeAccountDialogLayout();
initializeMobileMenuState();
initializeMegaMenuHover();

document.addEventListener('shopify:section:load', initializeAccountDialogLayout);
document.addEventListener('shopify:section:load', initializeMobileMenuState);
document.addEventListener('shopify:section:load', initializeMegaMenuHover);
window.addEventListener('resize', updateAccountDialogScrollbarOffset);
